"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configService = void 0;
const assert_1 = require("assert");
function configService(configProviders) {
    const listeners = [];
    return {
        async load() {
            await Promise.all(configProviders.map((provider) => provider.load()));
            listeners.forEach((listener) => listener(this));
        },
        has(key) {
            return configProviders.some((provider) => provider.has(key));
        },
        get(key) {
            const provider = configProviders.find((p) => p.has(key));
            return provider && provider.get(key);
        },
        getOrDefault(key, defaultValue) {
            return this.get(key) || String(defaultValue);
        },
        getRequired(key) {
            const value = this.get(key);
            (0, assert_1.strict)(value, `Configuration value with key "${key}" is required. Please check your configuration sources`);
            return value;
        },
        getInteger(key) {
            const value = this.get(key);
            return value ? parseInt(value, 10) : undefined;
        },
        getObjectRequired(key) {
            const value = this.getRequired(key);
            return JSON.parse(value);
        },
        getMany(...keys) {
            return keys.map((key) => this.get(key));
        },
        getManyRequired(...keys) {
            const missingKeys = [];
            const values = keys.map((key) => {
                const value = this.get(key);
                if (!value) {
                    missingKeys.push(key);
                }
                return value;
            });
            (0, assert_1.strict)(missingKeys.length === 0, `Configuration values with keys "${missingKeys}" are required. Please check your configuration sources`);
            return values;
        },
        getAll() {
            return new Map(configProviders
                .slice() // reverse will mutate existing array, getting a copy first
                .reverse() // we need to reverse order of providers in order to resolve original priority when map is 'merged' below
                .map((provider) => provider.getAll())
                .flatMap((params) => Array.from(params.entries())));
        },
        getAllAsObject() {
            return Object.fromEntries(this.getAll());
        },
        addListener(listener) {
            listeners.push(listener);
        },
    };
}
exports.configService = configService;
//# sourceMappingURL=configService.js.map